// Module
var code = "<div> <wt-generic-select is-disabled=\"vm.isDisabled\" items=\"vm.levels\" model=\"vm.model\" name=\"{{vm.name}}\"> </wt-generic-select> </div>";
// Exports
module.exports = code;